import { ProgressTheme } from '../../base/tokens';

export const progress: ProgressTheme = {
  circular: {
    wrapper: 'relative flex items-center justify-center w-48 h-48',
    svg: 'w-full h-full -rotate-90 transform',
    track: {
      width: '8',
      fill: 'transparent',
      stroke: 'currentColor',
      radius: '70',
      center: '96,96'
    },
    indicator: {
      width: '8',
      fill: 'transparent',
      stroke: 'currentColor',
      linecap: 'round',
      radius: '70',
      center: '96,96'
    },
    text: {
      base: 'absolute inset-0 flex items-center justify-center',
      value: 'text-2xl font-medium text-cyan-400'
    }
  },
  variants: {
    primary: 'stroke-cyan-900/20',
    secondary: 'stroke-cyan-500 transition-all duration-300'
  }
}; 